export const licenseAllStatus = {
  AdditionalDocumentRequest: "additional documents request",
  RequestStatutoryFee: "request statutory fee",
  StatutoryFeeRequested: "statutory fee requested",
  StatutoryFeeApproved: "statutory fee approved",
  StatutoryFeePaid: "statutory fee paid",
};
